<template>
  <div :class="componentClassName">
    <div class="a-price-table-row__content">
      <span class="a-price-table-row__title">
        {{ title }}
        <span class="a-price-table-row__subtitle">{{ subtitle }}</span>
      </span>
      <a-uom-text v-if="price" :price="price" :unit="unit" />
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AUomText from '@/components/atoms/uom-text/index.vue';

export default {
  name: 'a-price-table-row',
  components: {
    AUomText,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: null,
      required: true,
    },
    subtitle: {
      type: String,
      default: null,
    },
    price: {
      type: String,
      default: null,
    },
    unit: {
      type: String,
      default: null,
    },
    summary: {
      type: Boolean,
      default: false,
    },
    total: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-price-table-row', this.summary ? 'summary' : '', this.total ? 'total' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
};
</script>
